(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["algolia_instantsearch"] && !Shopify.designMode) return;
  try {
    (function () {
    const instantSearchContainer = document.querySelector('#algolia-shopify-instantsearch');
    const NL_Algolia_instantsearch_omnibus_enabled = document.querySelector(
      '[data-algolia-instantsearch-omnibus-enabled="true"]'
    )
      ? true
      : false;

    const addInstantSearchEvents = function () {
      const instantsearchContainer = document.querySelector('#algolia-shopify-instantsearch');

      instantsearchContainer.addEventListener('click', () => {
        const item = event.target.closest('.ais-show-facets-button');

        if (item && instantsearchContainer.contains(item)) {
          instantsearchContainer.classList.add('ais-show-facets');
          document.documentElement.classList.add('js-drawer-open', 'lock-scroll');
        }
      });
    };

    const setFilterStickyPosition = function () {
      const header = document.querySelector('[data-section-type="header"]');
      const filtersContainer = document.querySelector('.ais-search-header');
      const headerHeight = header?.offsetHeight;

      if (headerHeight && filtersContainer) {
        filtersContainer.style.top = headerHeight - 1 + 'px';
      }
    };

    const initFiltersDrawer = function () {
      theme.FilterDrawer = new theme.Drawers('InstantSearchFiltersDrawer', 'instant-search-filters', true);
    };

    const hitEnrichments = [
      {
        section: 'secondary-image',
        apply(hitEl, html) {
          const imageMask = hitEl.querySelector('.grid-product__image-mask');
          if (!imageMask || imageMask.querySelector('.grid-product__secondary-image')) return;

          const wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          const secondaryImageEl = wrapper.querySelector('.grid-product__secondary-image');
          if (!secondaryImageEl) return;

          secondaryImageEl.querySelector('image-element')?.classList?.add('aos-animate');
          imageMask.appendChild(secondaryImageEl);
        },
      },
    ];

    const hitEnrichmentCache = new Map();

    const fetchHitEnrichments = (handle) => {
      if (hitEnrichmentCache.has(handle)) return hitEnrichmentCache.get(handle);
      const sections = hitEnrichments.map((e) => e.section).join(',');
      const promise = fetch(`${Shopify.routes.root}products/${handle}?sections=${sections}`).then((res) => res.json());
      hitEnrichmentCache.set(handle, promise);
      return promise;
    };

    const syncProductCount = () => {
      const statsEl = document.querySelector('.ais-stats--nb-results');
      const productCountEl = document.getElementById('productCount');
      if (statsEl && productCountEl) {
        productCountEl.textContent = statsEl.textContent.trim();
        productCountEl.style.display = 'block';
      }
    };

    const wireNativeFilterButton = () => {
      const nativeFilterBtn = document.getElementById('FilterDrawerButton');
      if (nativeFilterBtn && !nativeFilterBtn.dataset.algoliaWired) {
        nativeFilterBtn.dataset.algoliaWired = 'true';
        nativeFilterBtn.addEventListener(
          'click',
          function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            document.querySelector('.ais-show-facets-button')?.click();
          },
          true
        );
      }
    };

    const initProxySortBy = function () {
      const sortByAlgoliaSelector = document.querySelector('.ais-SortBy-select');
      const sortProxy = document.querySelector('[data-algolia-sort-order-proxy]');
      if (!sortByAlgoliaSelector || !sortProxy) return;

      const proxyOptionsList = sortProxy.querySelector('.ais-sort__proxy-options');
      proxyOptionsList.innerHTML = '';

      sortByAlgoliaSelector.querySelectorAll('option').forEach((option) => {
        const proxyOption = document.createElement('li');
        proxyOption.setAttribute('data-sort-value', option.value);
        proxyOption.textContent = option.textContent;

        proxyOption.addEventListener('click', function (e) {
          const proxySelectedSortValue = e.target.getAttribute('data-sort-value');
          const selectedSortOption = sortByAlgoliaSelector.querySelector(`option[value="${proxySelectedSortValue}"]`);

          if (selectedSortOption) {
            sortByAlgoliaSelector.value = selectedSortOption.value;
            sortByAlgoliaSelector.dispatchEvent(new Event('change', { bubbles: true }));
            setCurrentProxySortByValue();
          }
        });

        sortProxy.querySelector('.ais-sort__proxy-options').appendChild(proxyOption);
      });
    };

    const setCurrentProxySortByValue = function () {
      const sortByAlgoliaSelector = document.querySelector('.ais-SortBy-select');
      const sortProxy = document.querySelector('[data-algolia-sort-order-proxy]');
      if (!sortByAlgoliaSelector || !sortProxy) return;
      const currentValue = sortByAlgoliaSelector.value;

      sortProxy.querySelectorAll('.ais-sort__proxy-options li').forEach((option) => {
        if (option.getAttribute('data-sort-value') === currentValue) {
          option.classList.add('ais-sort__proxy-option--selected');
        } else {
          option.classList.remove('ais-sort__proxy-option--selected');
        }
      });
    };

    const applyHitEnrichments = () => {
      const hits = instantSearchContainer.querySelectorAll('[data-handle]:not([data-enriched])');

      hits.forEach((hitEl) => {
        const handle = hitEl.dataset.handle;
        if (!handle) return;

        hitEl.dataset.enriched = 'true';

        fetchHitEnrichments(handle).then((data) => {
          hitEnrichments.forEach(({ section, apply }) => {
            if (data[section]) apply(hitEl, data[section]);
          });
        });
      });
    };

    document.addEventListener('DOMContentLoaded', () => {
      window.AlgoliaHelpers.onInstantSearch('render', () => {
        // On slow network, it's possible that the AOS observer is not initialized when
        // the widgets are added, so we need to make sure it's initialized after everything
        // is rendered. This is required for the AOS animations to work properly on the widgets.
        window.AlgoliaHelpers.scheduleAOSRefresh();

        applyHitEnrichments();
        syncProductCount();
        wireNativeFilterButton();
        initProxySortBy();
        setCurrentProxySortByValue();
      });
    });

    document.addEventListener('algolia.hooks.initialize', function () {
      algoliaShopify.hooks.registerHook('beforeInstantSearchConfigurationOptions', function (options) {
        window.AlgoliaHelpers.mergeTranslations(options);

        const filtersTrigger =
          document
            .querySelector('[data-algolia-search-filters-trigger]')
            ?.getAttribute('data-algolia-search-filters-trigger') || 'FILTER & SORT';
        window.AlgoliaHelpers.addTranslation('showFilters', filtersTrigger);

        return options;
      });

      algoliaShopify.hooks.registerHook('beforeInstantSearchStartAddWidgets', function () {
        const { configure } = window.algoliaShopify.externals.widgets;
        configureWidget = configure({
          facetingAfterDistinct: false,
        });

        return [configureWidget];
      });

      algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function (_defaultTemplate, data, html) {
        // Needs to be initialized AFTER 'InstantSearchMainTemplate' is rendered so we queue it!
        window.setTimeout(() => {
          initFiltersDrawer();
        }, 10);

        const searchEnabledOnCollection = document.querySelector('[data-algolia-search-enabled]');
        const displaySearchBox = !document.body.classList.contains('template-collection') || searchEnabledOnCollection;

        return html`
          <div class="ais-page">
            <div style="display: none!important;" class="ais-facets-button">
              ${algoliaShopify.translations.showFilters}
            </div>
            <div class="ais-facets drawer drawer--right" id="InstantSearchFiltersDrawer" tabindex="-1">
              <button class="ais-close-facets-button js-drawer-close">
                ${algoliaShopify.translations.closeFiltersDrawer}
              </button>

              <div class="ais-facet-dropdown-wrapper" data-algolia-sort-order-proxy>
                <label for="algolia-sort-order" class="ais-facet--header ais-header"
                  >${algoliaShopify.translations.sortBy}</label
                >
                <input class="ais-dropdown-checkbox" type="checkbox" id="algolia-sort-order" name="dropdown" checked />
                <div class="ais-facet-dropdown-container">
                  <div class="ais-Panel">
                    <div class="ais-Panel-body">
                      <div>
                        <ul class="ais-sort__proxy-options ais-RefinementList-list"></ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="ais-current-refined-values-container"></div>

              <div class="ais-sort">
                ${data.multipleSortOrders
                  ? html`
                      <span class="hidden-label">${algoliaShopify.translations.sortBy}</span>
                      <span class="ais-sort-orders-container"></span>
                    `
                  : html` ${algoliaShopify.translations.sortBy} ${algoliaShopify.translations.relevance} `}
              </div>

              <div class="ais-clear-refinements-container"></div>
              ${algoliaShopify.config.app_blocks_dynamic_widgets_beta_enabled
                ? html` <div class="ais-dynamic-widgets-container"></div> `
                : data.facets.map(
                    (facet) =>
                      html`
                        <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
                          <label
                            for="${facet.escapedName}"
                            class="ais-range-slider--header ais-facet--header ais-header"
                            >${facet.title}</label
                          >
                          <input
                            class="ais-dropdown-checkbox"
                            type="checkbox"
                            id="${facet.escapedName}"
                            name="dropdown"
                          />
                          <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                        </div>
                      `
                  )}
            </div>
            <div class="ais-block">
              <div class="ais-search-header">
                <div class="ais-search-header__inner">
                  <div class="ais-input" style="${displaySearchBox ? '' : 'display: none;'}">
                    <span class="ais-input-label">${algoliaShopify.translations.searchLabel}</span>
                    <div class="ais-input-button">
                      <div class="ais-clear-input-icon"></div>
                    </div>
                  </div>
                  <div class="ais-stats-container"></div>
                  <div class="ais-facets-button__wrapper">
                    <button class="ais-show-facets-button btn btn--tertiary js-drawer-open-instant-search-filters">
                      ${algoliaShopify.translations.showFilters}
                    </button>
                  </div>
                </div>
                <div class="ais-change-display">
                  <span class="ais-change-display-block ais-change-display-selected"
                    ><i class="fa fa-th-large"></i
                  ></span>
                  <span class="ais-change-display-list"><i class="fa fa-th-list"></i></span>
                </div>
              </div>
              <div class="ais-search-box-container" style="${displaySearchBox ? '' : 'display: none;'}"></div>
              <div class="ais-hits-container ais-results-as-block"></div>
            </div>
            <div class="ais-pagination-container"></div>
          </div>
        `;
      });

      const colorFilterMarkup = function (item, html) {
        const itemValueHandle = item?.value?.toLowerCase();
        return html`
          <span class="color-swatch color-swatch--filter color-swatch--${itemValueHandle}" title="${item.label}">
            ${item.label}
          </span>
        `;
      };

      algoliaShopify.hooks.registerHook(
        'beforeInstantSearchFacetItemTemplate',
        function (_defaultTemplate, item, html) {
          const filterIsColor = item?.attribute === 'meta.basic_integration.color_family_pim';

          return html`
            <label class="${item.cssClasses.label}">
              ${item.type === 'disjunctive' &&
              (item.isRefined
                ? html` <input type="checkbox" class="${item.cssClasses.checkbox}" checked />
                    ${filterIsColor ? colorFilterMarkup(item, html) : html`<span class="tag__checkbox"></span>`}`
                : html`
                    <input type="checkbox" class="${item.cssClasses.checkbox}" />
                    ${filterIsColor ? colorFilterMarkup(item, html) : html`<span class="tag__checkbox"></span>`}
                  `)}
              <span class="label-count-wrapper">
                <span class="tag__text"> ${item.label} </span>
                <span class="${item.cssClasses.count} count-filter">
                  (${algoliaShopify.helpers.formatNumber(item.count)})
                </span>
              </span>
            </label>
          `;
        }
      );

      algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function (_defaultTemplate, data, html) {
        return html`
          ${data.hasOneResult &&
          html` <span class="ais-stats--nb-results"> 1 ${algoliaShopify.translations.resultsFound} </span> `}
          ${data.hasManyResults &&
          html`
            <span class="ais-stats--nb-results">
              ${algoliaShopify.helpers.formatNumber(data.nbHits)} ${algoliaShopify.translations.resultsFound}
            </span>
          `}
        `;
      });

      algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString', function (defaultFilter) {
        if (defaultFilter && defaultFilter.includes('collection_ids')) {
          const collectionIDFilterRegex = /collection_ids:"\w+"/g;
          const container = document.getElementById('algolia-shopify-instantsearch');
          const collectionHandle = container && container.dataset.collectionHandle;

          if (collectionHandle) {
            return defaultFilter.replace(collectionIDFilterRegex, 'collections:' + collectionHandle);
          }
        }

        return defaultFilter;
      });

      algoliaShopify.hooks.registerHook(
        'beforeInstantSearchProductTemplate',
        function (_defaultTemplate, hit, html, components) {
          const itemTitleMap = window.AlgoliaHelpers.getBasicNetTitleParts(hit.title);

          // Prices formats
          const itemIsOnSale = window.AlgoliaHelpers.isOnSale(hit);
          const itemPriceVaries = window.AlgoliaHelpers.doesItemPriceVary(hit);
          const variantMinPrice = hit.variants_min_price;
          const variantCompareAtPriceMin = hit.variants_compare_at_price_min;
          const variantCurrency = hit.currency;
          const omnibusRaw = hit?.meta?.omnibus?.bestPrice;
          let itemOmnibus;

          if (omnibusRaw && typeof omnibusRaw === 'string') {
            itemOmnibus = JSON.parse(omnibusRaw);
          } else {
            itemOmnibus = omnibusRaw;
          }

          const displayOmnibusNotice =
            NL_Algolia_instantsearch_omnibus_enabled && itemOmnibus?.amount > 0 && itemIsOnSale;
          const omnibusPrice = displayOmnibusNotice
            ? parseInt(itemOmnibus?.amount, 10) * 100
            : variantCompareAtPriceMin;

          let displayPrice = window.AlgoliaHelpers.wrapCurrency(
            window.AlgoliaHelpers.currencyFormattingAwarePrice(
              algoliaShopify.formatMoney(variantMinPrice * 100, variantCurrency)
            )
          );
          const strikedPrice = window.AlgoliaHelpers.wrapCurrency(
            window.AlgoliaHelpers.currencyFormattingAwarePrice(
              algoliaShopify.formatMoney(variantCompareAtPriceMin * 100, variantCurrency)
            )
          );

          const omnibusNoticePrice = window.AlgoliaHelpers.wrapCurrency(
            window.AlgoliaHelpers.currencyFormattingAwarePrice(
              algoliaShopify.formatMoney(omnibusPrice, variantCurrency)
            )
          );

          if (itemPriceVaries) {
            displayPrice = window.AlgoliaHelpers.addPriceVariesLabel(displayPrice);
          }

          const strikedPriceTemplate = strikedPrice
            ? html`<span class="ais-hit--SalePrice"
                >${(() => html`<span dangerouslySetInnerHTML=${{ __html: strikedPrice }} />`)()}</span
              >`
            : '';

          const sellingPriceTemplate = itemIsOnSale
            ? html`<span class="ais-hit--RegularPrice ais-hit--RegularPrice--on-sale"
                >${(() => html`<span dangerouslySetInnerHTML=${{ __html: displayPrice }} />`)()}</span
              >`
            : html`<span class="ais-hit--RegularPrice"
                >${(() => html`<span dangerouslySetInnerHTML=${{ __html: displayPrice }} />`)()}</span
              >`;

          const saleLabel = itemIsOnSale
            ? html`<span class="ais-hit--SaleLabel grid-product__tag grid-product__tag--sale"></span>`
            : ''; // ToDo: dynamic value for label

          const omnibusNotice = displayOmnibusNotice
            ? html`<div class="ais-hit--ItemContentPricePrevious">
                <span class="ais-hit--OmnibusNotice grid-product__notice--omnibus">
                  ${(() => html`<span dangerouslySetInnerHTML=${{ __html: omnibusNoticePrice }} />`)()}</span
                >
              </div>`
            : '';

          const withImageWidth = (url, width) => {
            if (!url) return '';
            const urlObj = new URL(url);
            urlObj.searchParams.set('width', width);
            return urlObj.toString();
          };
          const primaryImageBaseUrl = algoliaShopify.helpers.originalImage(hit);
          const primaryImageWidths = [352, 832, 1080];
          const primaryImageSrc = withImageWidth(primaryImageBaseUrl, 1080);
          const primaryImageSrcSet = primaryImageWidths
            .map((width) => `${withImageWidth(primaryImageBaseUrl, width)} ${width}w`)
            .join(', ');

          return html`
            <div
              class="ais-hit ais-product grid-product__content grid__item grid-product"
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              data-handle="${hit.handle}"
              data-distinct="${hit._distinct}"
              data-variant-id="${hit.objectID}"
              data-product-id="${hit.id}"
              onClick="${(e) => {
                // Prevent redirection when clicking on wishlist button (if you have one in your template)
                if (e.target.closest('.bn-wishlist-icon')) {
                  e.stopPropagation();
                  e.stopImmediatePropagation();
                }

                algoliaShopify.helpers.handleItemClick(hit);
              }}"
            >
              ${saleLabel}
              <div class="grid__item-image-wrapper">
                <div class="grid-product__image-mask">
                  <div class="image-wrap" style="height: 0; padding-bottom: 100.0%;">
                    <image-element data-aos="image-fade-in" data-aos-offset="150">
                      <img
                        class="grid-product__image image-element"
                        src="${primaryImageSrc}"
                        srcset="${primaryImageSrcSet}"
                        sizes="(min-width: 769px) 25vw, 50vw"
                        alt="${hit.title} - ${hit.variant_title}"
                        loading="lazy"
                        width="1080"
                        height="1080"
                      />
                    </image-element>
                  </div>
                </div>
              </div>

              <div class="ais-hit--details">
                <p class="ais-hit--title">
                  <a
                    class="grid-product__link"
                    data-algolia-index="${hit.index}"
                    data-algolia-position="${hit.productPosition}"
                    data-algolia-queryid="${hit.queryID}"
                    data-algolia-objectid="${hit.objectID}"
                    href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                    title="${itemTitleMap.title}"
                  >
                    <p class="product_brand grid-product__title grid-product__title--body" style="font-weight: 600; margin: 0;">${window.AlgoliaHelpers.getProductBrand(
                      hit
                    )}</p>
                    ${itemTitleMap.title} ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
                    <p class="colorname-title ais-hit--subtitle" title="${itemTitleMap.color}">${itemTitleMap.color}</p>
                  </a>
                </p>
                <p class="ais-hit--price">
                  <div class="ais-hit--ItemContentPrice">
                    <div class="ais-hit--ItemContentPriceCurrent">
                      ${sellingPriceTemplate} ${itemIsOnSale && strikedPriceTemplate}
                    </div>
                    ${omnibusNotice}
                  </div>
                </p>
                <!-- Extra info examples - Remove the display: none to show them -->
                <p class="ais-hit--info" style="display: none">
                  ${
                    hit.sku &&
                    html` <span class="algolia-sku">${components.Highlight({ attribute: 'sku', hit })}</span> `
                  }
                  ${
                    hit.barcode &&
                    html` <span class="algolia-barcode">${components.Highlight({ attribute: 'barcode', hit })}</span> `
                  }
                  ${hit.weight && html` <span class="algolia-weight">${hit.weight}</span> `}
                  ${!hit.taxable && html` <span class="algolia-taxable">${algoliaShopify.translations.taxFree}</span> `}
                </p>
                <!-- Tags example - Remove the display: none to show them -->
                <p class="ais-hit--tags" style="display: none">
                  ${hit?._highlightResult.tags?.map((tag) => html` <span class="ais-hit--tag">${tag.value}</span> `)}
                </p>
                ${
                  !hit._distinct &&
                  html`
                    <form
                      id="algolia-add-to-cart-${hit.objectID}"
                      style="display: none;"
                      action="/cart/add"
                      method="post"
                      enctype="multipart/form-data"
                    >
                      <input type="hidden" name="id" value="${hit.objectID}" />
                    </form>
                    <p class="ais-hit--cart">
                      ${hit.can_order
                        ? html`
                            <button class="ais-hit--cart-button" data-form-id="algolia-add-to-cart-${hit.objectID}">
                              ${algoliaShopify.translations.addToCart}
                            </button>
                          `
                        : html`
                            <button class="ais-hit--cart-button ais-hit--cart-button__disabled">
                              ${algoliaShopify.translations.outOfStock}
                            </button>
                          `}
                    </p>
                  `
                }
              </div>
            </div>
          `;
        }
      );
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    (function () {
    // Hooking into the DOM load event to run our code after the DOM is ready ( to make sure calculations are correct )
    const onReady = function (fn) {
      if (typeof fn !== 'function') return console.warn('onReady skipped: No proper function provided');

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn, { once: true });
      } else {
        queueMicrotask ? queueMicrotask(fn) : fn();
      }
    };

    const calcAutoCompleteTop = function () {
      let autocompleteTop = 0;
      const headerTop = document.querySelector('.shopify-section-group-header-group .toolbar');
      const siteHeaderIsSticky = document.querySelector('.site-header--stuck');

      if (headerTop) {
        autocompleteTop = siteHeaderIsSticky ? 0 : headerTop.getBoundingClientRect().top + headerTop.clientHeight;
      }

      document.body.style.setProperty('--nl-autocomplete-top', `${autocompleteTop}px`);
    };

    const initExtras = function () {
      const autocompleteForm = document.querySelector('predictive-search .aa-Form');
      const autocompleteScreen = document.querySelector('predictive-search .predictive__screen');
      if (!autocompleteForm || !autocompleteScreen) return;

      const closeButtonEl = document.createElement('button');
      closeButtonEl.classList.add('aa-CloseButton');
      autocompleteForm.append(closeButtonEl);

      const closeButton = autocompleteForm.querySelector('.aa-CloseButton');

      if (!closeButton) return;

      closeButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const searchPanel = document.querySelector('.aa-Panel');

        if (searchPanel) {
          searchPanel.remove();
        }

        if (autocompleteScreen) {
          autocompleteScreen.click();
        }
      });
    };

    const stateIsDefault = function (state) {
      const cleanQuery = state.query.trim();
      return cleanQuery === '' /* || cleanQuery.length <= 3 */ && state.isOpen === true;
    };
    const adaptPanelHeight = function () {
      window.setTimeout(function () {
        const algoliaPanel = document.querySelector('.aa-Panel');
        document.body.style.setProperty('--nl-algolia-panel-top', `${algoliaPanel?.getBoundingClientRect().top}px`); // Adapting panel height to design
      }, 50);
    };

    const getAlgoliaDynamicIndexes = function () {
      const predictiveSearchEl = document.querySelector('predictive-search');
        const currentMarket = predictiveSearchEl?.getAttribute('data-algolia-index-suffix')
          ? predictiveSearchEl.getAttribute('data-algolia-index-suffix')
          : '';

        const brand = predictiveSearchEl?.getAttribute('data-algolia-brand');
        const currentLanguage = window.algoliaShopify.shopify.market.language.shop_locale.locale;
        const currentMarketSuffix = currentMarket ? `${currentMarket}_` : '';

        return {
          suffix: `_${currentMarketSuffix}${currentLanguage}`,
          suggestions : `shopify_${brand}_query_suggestions_${currentLanguage}`,
          brand: brand
        }
    }

    const NL_i18n_Algolia = {};
    const NL_Algolia_form = document.querySelector('form[data-search="algolia"]');
    NL_i18n_Algolia['autocomplete_placeholder'] = NL_Algolia_form?.getAttribute('data-placeholder');
    const NL_Algolia_default_template_section = document.querySelector('#nl__aa-Default-Template-template');
    let NL_Algolia_default_template;

    const NL_Algolia_autocomplete_omnibus_enabled = document.querySelector('[data-algolia-autocomplete-omnibus-enable="true"]') ? true : false;

    if (NL_Algolia_default_template_section) {
      NL_Algolia_default_template = NL_Algolia_default_template_section.innerHTML;
    }

    document.addEventListener('algolia.hooks.initialize', function () {
      algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function (options) {
        const algolia = window.algoliaShopify;
        const config = algolia.config;
        const algoliaTranslationsMetafieldEl = document.querySelector('[data-algolia-custom-translation-keys]');
        let algoliaCustomTranslationKeys = {};

        if (algoliaTranslationsMetafieldEl) {
          algoliaCustomTranslationKeys = JSON.parse(
            algoliaTranslationsMetafieldEl?.getAttribute('data-algolia-custom-translation-keys')
          );
        }

        // Customize options here
        options.focus = true; // ToDo: Might be better implementation! Check why focus:true is not working
        options.openOnFocus = true;

        if (algoliaCustomTranslationKeys.clear) {
          options.translations = {
            clearButtonTitle: algoliaCustomTranslationKeys.clear,
          };
        }

        // Timeout is needed for algolia to be ready (it's async so we're setting microtask in queue instead of stack)
        window.setTimeout(initExtras, 100);

        if (NL_i18n_Algolia?.autocomplete_placeholder) {
          options.placeholder = NL_i18n_Algolia.autocomplete_placeholder;
        }

        const algoliaDynamicIndexes = getAlgoliaDynamicIndexes();


        const bannerPlugin = {
          getSources({ query }) {
            return [
              {
                sourceId: "queryRuleBanner",
                async getItems() {
                  const results = await algolia.searchClient.search([
                    {
                      indexName: `shopify_${algoliaDynamicIndexes.brand}_products${algoliaDynamicIndexes.suffix}`,
                      query,
                      params: {
                        hitsPerPage: 0,
                        clickAnalytics: false,
                        ruleContexts: ["autocomplete-banner"],
                      },
                    },
                  ]);

                  const renderingContent =
                    results.results[0]?.renderingContent;
                  const banners =
                    renderingContent?.widgets?.banners;

                  if (!banners || banners.length === 0) return [];

                  // Return banners as synthetic items so Autocomplete can render them
                  return banners.map((banner, i) => ({
                    __autocomplete_id: `banner-${i}`,
                    imageUrl: banner.image?.urls[0]?.url ?? null,
                    linkUrl: banner.link?.url ?? null,
                  }));
                },
                templates: {
                  item({ item, html }) {
                    if (!item.imageUrl) return null;

                    const wrapper = item.linkUrl
                      ? html`<a href=${item.linkUrl} class="aa-BannerLink">
                          <img
                            src=${item.imageUrl}
                            class="aa-BannerImage"
                            alt="Banner"
                          />
                        </a>`
                      : html`<div class="aa-Banner">
                          <img
                            src=${item.imageUrl}
                            class="aa-BannerImage"
                            alt="Banner"
                          />
                        </div>`;

                    return wrapper;
                  },
                },
              },
            ];
          },
        };

        options.plugins.push(bannerPlugin);

        return options;
      });

      algoliaShopify.hooks.registerHook('beforeAutocompleteAsyncFunction', async function () {
        const algoliaDynamicIndexes = getAlgoliaDynamicIndexes();

        window.algoliaShopify.config.index_suffix = algoliaDynamicIndexes.suffix;
        window.algoliaShopify.config.query_suggestions_index_name = algoliaDynamicIndexes.suggestions;
      });

      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteMainTemplate',
        function (_defaultTemplate, templateOptions, elements, displaySuggestions) {
          const { html, state } = templateOptions;

          adaptPanelHeight();

          if (stateIsDefault(state)) {
            return html`<div dangerouslySetInnerHTML=${{ __html: NL_Algolia_default_template }} />`; // Return empty template when no query
          }

          return html`
            <div class="aa-PanelLayout aa-Panel--scrollable">
              <div class="aa-PanelSections">
                <div class="aa-PanelSection--left">
                  ${
                    displaySuggestions &&
                    html`
                      <div class="aa-SourceHeader">
                        <span class="aa-SourceHeaderTitle"
                          >${algoliaShopify.translations.suggestions}</span
                        >
                        <div class="aa-SourceHeaderLine" />
                      </div>
                      ${elements.querySuggestionsPlugin}
                    `
                  }
                  ${elements.collections} ${elements.pages}
                  ${elements.redirectUrlPlugin}
                </div>
                <div class="aa-PanelSection--right">
                  ${elements.queryRuleBanner && html`<div class="aa-PanelSection--banners">${elements.queryRuleBanner}</div>`}
                  ${elements.products}
                </div>
              </div>
            </div>
          `;
        }
      );

      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteNoResultsTemplate',
        function (_defaultTemplate, templateOptions, elements, displaySuggestions) {
          const { html, state } = templateOptions;

          adaptPanelHeight();

          const NL_Algolia_default_template_panel = html`<div
            dangerouslySetInnerHTML=${{ __html: NL_Algolia_default_template }}
          />`;

          if (stateIsDefault(state)) {
            return NL_Algolia_default_template_panel; // Return empty template when no query
          }

          return html`
            <div class="aa-PanelLayout aa-Panel--scrollable">
              <div class="aa-no-results">
                <p class="aa-NoResultsHeader">${algoliaShopify.translation_helpers.no_result_for(state.query)}</p>
                <a class="btn btn--secondary btn--small" href="${window.Shopify.routes.root}collections/all">
                  ${algoliaShopify.translations.allProducts}
                </a>
              </div>
              <div class="aa-no-results--default-template">${NL_Algolia_default_template_panel}</div>
            </div>
          `;
        }
      );

      algoliaShopify.hooks.registerHook(
        "beforeAutocompleteCollectionsTemplate",
        (_defaultTemplate, templateOptions, itemLink) => {
          const { html, item, components } = templateOptions;
          return html`
          <a href="${itemLink}" class="aa-ItemLink">
            <div class="aa-ItemWrapper">
              <div class="aa-ItemContent">
                <div class="aa-ItemIcon aa-ItemIcon--noBorder">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                    />
                  </svg>
                </div>
                <div class="aa-ItemContentBody">
                  <div class="aa-ItemContentTitle">
                    ${item.title}
                  </div>
                </div>
              </div>
            </div>
          </a>
        `;
        },
      );

      algoliaShopify.hooks.registerHook(
        'beforeAutocompletePagesTemplate',
        (_defaultTemplate, templateOptions, itemLink) => {
          const { html, item, components } = templateOptions;
          return html`
            <a href="${itemLink}" class="aa-ItemLink aa-ProductItem">
              <div class="aa-ItemWrapper">
                <div class="aa-ItemContent">
                  <div class="aa-ItemIcon aa-ItemIcon--noBorder">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <div class="aa-ItemContentBody">
                    <div class="aa-ItemContentTitle">${item.title}</div>
                  </div>
                </div>
              </div>
            </a>
          `;
        }
      );


      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteSuggestionsTemplate',
        function (_defaultTemplate, templateOptions) {
          const { html, state, item, components } = templateOptions;

          adaptPanelHeight();

          return html`
            <a class="aa-ItemLink aa-ItemWrapper" href="${window.Shopify.routes.root}search?q=${item.query}">
              <div class="aa-ItemContent">
                <div class="aa-ItemIcon aa-ItemIcon--noBorder">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path
                      d="M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z"
                    />
                  </svg>
                </div>
                <div class="aa-ItemContentBody">
                  <div class="aa-ItemContentTitle">${item.query}</div>
                </div>
              </div>
            </a>
          `;
        }
      );

      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteMainProductsTemplate',
        function (_defaultTemplate, templateOptions, elements) {
          const { html, state } = templateOptions;

          adaptPanelHeight();

          if (stateIsDefault(state)) {
            return html`<div dangerouslySetInnerHTML=${{ __html: NL_Algolia_default_template }} />`; // Return empty template when no query
          }

          return _defaultTemplate;
        }
      );

      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteProductTemplate',
        function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
          // Modify default options, then return them
          const { html, item, components } = templateOptions;

          const itemTitleMap = window.AlgoliaHelpers.getBasicNetTitleParts(item.title);

          // Prices formats
          const itemIsOnSale = window.AlgoliaHelpers.isOnSale(item);
          const itemIsNewIn = window.AlgoliaHelpers.isNewIn(item);
          const itemPriceVaries = window.AlgoliaHelpers.doesItemPriceVary(item);
          const variantMinPrice = item.variants_min_price;
          const variantCompareAtPriceMin = item.variants_compare_at_price_min;
          const variantCurrency = item.currency;
          const itemOmnibus = window.AlgoliaHelpers.getOmnibusPrice(item);

          const displayOmnibusNotice = NL_Algolia_autocomplete_omnibus_enabled && itemOmnibus?.amount > 0 && itemIsOnSale;
          const omnibusPrice = displayOmnibusNotice
            ? parseInt(itemOmnibus?.amount, 10) * 100
            : variantCompareAtPriceMin;

          let displayPrice = window.AlgoliaHelpers.wrapCurrency(
            window.AlgoliaHelpers.currencyFormattingAwarePrice(algoliaShopify.formatMoney(variantMinPrice * 100, variantCurrency))
          );
          const strikedPrice = window.AlgoliaHelpers.wrapCurrency(
            window.AlgoliaHelpers.currencyFormattingAwarePrice(algoliaShopify.formatMoney(variantCompareAtPriceMin * 100, variantCurrency))
          );

          const omnibusNoticePrice = window.AlgoliaHelpers.wrapCurrency(
            window.AlgoliaHelpers.currencyFormattingAwarePrice(algoliaShopify.formatMoney(omnibusPrice, variantCurrency))
          );

          if (itemPriceVaries) {
            displayPrice = window.AlgoliaHelpers.addPriceVariesLabel(displayPrice);
          }

          const strikedPriceTemplate = strikedPrice
            ? html`<span class="aa-SalePrice"
                >${(() => html`<span dangerouslySetInnerHTML=${{ __html: strikedPrice }} />`)()}</span
              >`
            : '';

          const sellingPriceTemplate = itemIsOnSale
            ? html`<span class="aa-RegularPrice aa-RegularPrice--on-sale"
                >${(() => html`<span dangerouslySetInnerHTML=${{ __html: displayPrice }} />`)()}</span
              >`
            : html`<span class="aa-RegularPrice"
                >${(() => html`<span dangerouslySetInnerHTML=${{ __html: displayPrice }} />`)()}</span
              >`;

          const label = itemIsOnSale ? html`<span class="aa-SaleLabel grid-product__tag grid-product__tag--sale"></span>` : itemIsNewIn ? html`<span class="aa-NewInLabel grid-product__tag grid-product__tag--new-in"></span>` : '';

          const omnibusNotice = displayOmnibusNotice
            ? html`<div class="aa-ItemContentPricePrevious">
                <span class="aa-OmnibusNotice grid-product__notice--omnibus">
                  ${(() => html`<span dangerouslySetInnerHTML=${{ __html: omnibusNoticePrice }} />`)()}</span
                >
              </div>`
            : '';

          return html`
            <a href="${itemLink}" class="aa-ItemLink aa-ProductItem" onClick="${() => trackSearchAttribution(item)}">
              <div class="aa-ItemContent">
                ${label}
                <div class="aa-ItemPicture aa-ItemPicture--loaded">
                  <img
                    src="${algoliaShopify.helpers.renderImage(item, 230).src}"
                    srcset="${algoliaShopify.helpers.renderImage(item, 230).srcset}"
                    sizes="${algoliaShopify.helpers.renderImage(item, 230).sizes}"
                    alt="${item.title}"
                  />
                </div>
                <div class="aa-ItemContentBody">
                  <div class="aa-ItemContentTitleWrapper">
                    <div class="aa-ItemContentTitle">
                      ${itemTitleMap.title}
                      <span hidden>${components.Highlight({ hit: item, attribute: 'title' })}</span>
                      <span class="algolia-variant">
                        ${itemTitleMap.color}
                        <span hidden>${algoliaShopify.helpers.variantTitleAddition(item, distinct)}</span>
                      </span>
                    </div>
                  </div>
                  <div class="aa-ItemContentPrice">
                    <div class="aa-ItemContentPriceCurrent">
                      ${sellingPriceTemplate} ${itemIsOnSale && strikedPriceTemplate}
                    </div>
                    ${omnibusNotice}
                  </div>
                </div>
              </div>
            </a>
          `;
        }
      );

      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteHeaderTemplate',
        function (_defaultTemplate, templateOptions, resource) {
          const { html, state } = templateOptions;

          const getViewAllLink = () => {
            if (resource == algoliaShopify.translations.products) {
              return html`<a
                class="btn btn--secondary btn--small"
                href="${window.Shopify.routes.root}search?q=${state.query}"
              >
                ${algoliaShopify.translations.allProducts}
              </a>`;
            }
          };

          // ToDo: check if resource is translated
          return html`
            <div class="aa-SourceHeader">
              <span class="aa-SourceHeaderTitle"> ${resource} </span>
            </div>
            ${getViewAllLink(resource, state.query)}
          `;
        }
      );

      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteFooterTemplate',
        function (_defaultTemplate, templateOptions) {
          const { html, state } = templateOptions;
          return html``; // Removed "See all results" button from footer
        }
      );
    });

    document.addEventListener('predictive-search:open', (e) => {
      window.setTimeout(function () {
        document.querySelector('form.aa-MainContainer input[type="search"]')?.focus();
      }, 100);
    });

    document.addEventListener('click', (e) => {
      const target = e.target;
      const predictiveSearchElement = document.querySelector('predictive-search[data-enabled="true"]');
      const searchPanel = document.querySelector('.aa-Panel');

      if (!predictiveSearchElement || !predictiveSearchElement.classList.contains('is-active')) return;
      if(target.closest('predictive-search') || target.closest('.aa-Panel')) return;

      predictiveSearchElement.close();

      if (searchPanel) {
        searchPanel.remove();
      }
    });

    // Making sure autocomplete top is updated everytime we open it, to compensate for scroll
    const searchBtn = document.querySelectorAll('.js-search-header');
    if (searchBtn && searchBtn.length > 0) {
      searchBtn.forEach((btn) => {
        btn.addEventListener('click', () => {
          calcAutoCompleteTop();
        });
      });
    }

    // Making sure autocomplete top is updated on page load
    onReady(calcAutoCompleteTop);
  })();
  } catch(e) { console.error(e); }
})();

})();
